// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1cxK6","rootSmall":"AddTileButton_rootSmall__3z4mX"};